import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white pt-20 pb-10">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-16">
          {/* Company Info */}
          <div>
            <div className="mb-6">
              <div className="h-[23px] w-auto flex items-center justify-center flex-shrink-0"><img src="/logo.png" alt="Ariv" className="h-[23px] w-auto object-contain brightness-0 invert" /></div>
            </div>
            <p className="text-slate-400 mb-6">
              Stay, Ride, Eat, Fix, Invest, Earn. Everything arrives.
            </p>
            <div className="flex gap-4">
              <a
                href="https://www.facebook.com/arivukapp"
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-400 hover:text-white transition-colors"
                aria-label="Ariv on Facebook"
              >
                <Facebook size={20} />
              </a>
            </div>
          </div>

          {/* Product Links */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Product</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/how-it-works" className="text-slate-400 hover:text-white transition-colors">
                  How It Works
                </Link>
              </li>
              <li>
                <Link to="/become-host" className="text-slate-400 hover:text-white transition-colors">
                  Become a Host
                </Link>
              </li>
              <li>
                <Link to="/" className="text-slate-400 hover:text-white transition-colors">
                  Browse Stays
                </Link>
              </li>
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Company</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-slate-400 hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/careers" className="text-slate-400 hover:text-white transition-colors">
                  Careers
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-slate-400 hover:text-white transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources Links */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Resources</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/help" className="text-slate-400 hover:text-white transition-colors">
                  Help Center
                </Link>
              </li>
              <li>
                <Link to="/host/calculator" className="text-slate-400 hover:text-white transition-colors">
                  STR Profit Calculator
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-slate-400 hover:text-white transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/cookies" className="text-slate-400 hover:text-white transition-colors">
                  Cookie Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-slate-400 hover:text-white transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/restricted-businesses" className="text-slate-400 hover:text-white transition-colors">
                  Restricted businesses
                </Link>
              </li>
              <li>
                <Link to="/host/payments-and-risk" className="text-slate-400 hover:text-white transition-colors">
                  Payments and seller risk
                </Link>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => window.dispatchEvent(new CustomEvent('open-cookie-preferences'))}
                  className="text-slate-400 hover:text-white transition-colors text-left"
                >
                  Cookie preferences
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Trading disclosures — Companies (Trading Disclosures) Regulations 2008 */}
        <div className="pt-8 border-t border-slate-800 text-center text-slate-500 space-y-2">
          <p className="text-sm text-slate-400">
            &copy; {new Date().getFullYear()} Ariv. A product of Brick &amp; Capital Ltd. All rights reserved.
          </p>
          <p className="text-xs">
            <strong className="text-slate-400">Brick &amp; Capital Ltd</strong> &middot;
            Registered in England and Wales, company number{' '}
            <a
              href="https://find-and-update.company-information.service.gov.uk/company/16655788"
              target="_blank"
              rel="noopener noreferrer"
              className="underline hover:text-white"
            >
              16655788
            </a>
            {' '}&middot; Registered office: Bowness House, 815 Old Kent Road, London SE15 1NX, United Kingdom
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
